import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
// import abcLogo from "../../../../assets/images/logo-fill.png";
import abcLogo from "../../../../assets/images/EPL_think_images/new_abc_logo.png";
import { AuthenticationContext } from "../../../../shared/context/AuthenticationContext";
import { UserContext } from "../../../../shared/context/UserContext";
import useMediaQuery from "../../../../hooks/useMediaQuery";
// import VendorService from '../../../../shared/services/VendorService';
import capitalizeFirstLetter from "../../../../utils/capitalizeFirstLetter";
import HeaderSidebar from "../header-sidebar/HeaderSidebar";
import HeaderSidebarAdvisor from "../header-sidebar/sidebar-middle/HeaderSidebarAdvisor";
import HeaderSidebarCorporate from "../header-sidebar/sidebar-middle/HeaderSidebarCorporate";
import { HeaderSidebarTab } from "../header-sidebar/_styles/HeaderSidebarTab";
import HeaderDropdown from "./header-dropdown/HeaderDropdown";
import HeaderDropdownButton from "./header-dropdown/HeaderDropdownButton";
import HeaderLinksJSON from "./header-links.json";
import HeaderUserDropdown from "./header-user-dropdown/HeaderUserDropdown";
import { HeaderWrapper } from "./_styles/HeaderWrapper";

function Header() {
  const isMobile = useMediaQuery("screen and (max-width: 991px)");
  const [showQnAs, setShowQnAs] = useState(false);

  const toggleQnAs = () => {
    setShowQnAs(!showQnAs);
  };
  return (
    <div class="main-header">
      <header class="white-bg">
        <div class="topbar">
          <div
            class="topbar__innercontainer"
            style={{ display: "flex", justifyContent: "flex-start"}}
          >
            <div class="topbar__innercontainer__rowbox row">
              <div class="topbar__innercontainer__rowbox__leftcol col-md-7 col-lg-7">
                <div class="topbar__innercontainer__rowbox__leftcol__logo">
                  <img src={abcLogo} alt="Aditya Birla Capital" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div class="financingsolutions">
          <div class="financingsolutions__containerbox ">
            <div class="financingsolutions__containerbox__innerbox row">
              <div class="financingsolutions__containerbox__innerbox__menu col-md-12 col-sm-12 col-12">
                <div
                  class="financingsolutions__containerbox__innerbox__menu__inner"
                  style={{
                    fontFamily: "pf_handbook_proregular",
                    color: "white",
                    alignContent: "left",
                    paddingBottom: "3px",
                    paddingTop: "2px",
                    paddingLeft: "20px",
                    fontSize: "14px",
                    justifyContent: "flex-start",
                  }}
                >
                  Aditya Birla Finance Limited
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="adityabirlafinancelimited d-flex justify-content-between align-items-center"
          style={{ paddingTop: "15px" }}
        >
          <div class="col-1 ml-auto">
          </div>
        </div> */}
        {/* <div className="projectTitle" style={{
          fontFamily: "pf_handbook_proregular",
          fontStyle: "normal",
          fontWeight: "400",
          fontSize: "18px",
          lineHeight: "22px",
          color: "#C7222A",
          display: "flex",
          alignContent: "justified",
          paddingBottom: "3px",
          paddingTop: "2px",
          justifyContent: "center",
          backgroundColor: "white",
        }}>
          Instant Personal Loan for Salaried Employees
        </div> */}
      </header>
    </div>
  );
}
export default Header;
